import React from 'react';
import { Box, BoxProps } from '@material-ui/core';

interface Props extends BoxProps {
  children: React.ReactNode;
}

const BoxWrapper: React.FC<Props> = ({ children, sx, ...rest }: Props) => {
  return (
    <Box
      component="div"
      sx={{
        padding: 16,
        border: '1px solid #E4E9F2',
        borderRadius: 4,
        ...sx,
      }}
      {...rest}
    >
      {children}
    </Box>
  );
};

export default BoxWrapper;
